import React, { FC, useEffect, useState } from "react";
import authService from "@http/services/auth.service";
import { useRedirectAfterLogin } from "@hooks/useRedirectAfterLogin";
import { useRouter } from "next/router";

const PublicRoute: FC = ({ children }) => {
  const router = useRouter();
  const [redirect] = useRedirectAfterLogin();
  const [checkingAuth, setCheckingAuth] = useState(true);
  const isHome = router.pathname === "/";

  useEffect(() => {
    // Home page (index) does its own auth bootstrap and redirect to login; avoid duplicate fetchUser
    if (isHome) {
      setCheckingAuth(false);
      return;
    }

    let mounted = true;

    const checkAlreadyAuthenticated = async () => {
      try {
        const user = await authService.fetchUser();
        if (!mounted) {
          return;
        }

        if (user) {
          localStorage.removeItem("redirect_after_login");
          router.replace(redirect || process.env.NEXT_PUBLIC_DASHBOARD_URL || "/dashboard");
          return;
        }
      } catch {
        // unauthenticated users should see public page
      }

      if (mounted) {
        setCheckingAuth(false);
      }
    };

    checkAlreadyAuthenticated();

    return () => {
      mounted = false;
    };
  }, [redirect, router, isHome]);

  if (checkingAuth) {
    return null;
  }

  return <>{children}</>;
};

export default PublicRoute;
